import React, {useCallback, useEffect, useRef, useState} from 'react';
import EventListener from 'react-event-listener';

import Portal from 'topmeteo/general/components/Portal';

import ToggleDrawButton from './ToggleDrawButton';
import ExportButton from '../Export';
import OpacitySlider from './OpacitySlider';
import SettingsButton from './SettingsButton';

const ButtonHeight = 40;
const Padding = 8;

const useHeight = panelOpen => {
    const controlsRef = useRef(null);
    const [height, setHeight] = useState(null);
    const [windowHeight, setWindowHeight] = useState(window.innerHeight);
    const handleResize = useCallback(({target}) => setWindowHeight(target.innerHeight), [setWindowHeight]);

    useEffect(
        () => {
            const {current: controlsNode} = controlsRef;

            if (controlsNode) {
                const count = controlsNode.querySelectorAll('button').length;
                const {height} = controlsNode.getBoundingClientRect();
                const offset = count * (ButtonHeight + Padding);

                setHeight(height - offset);
            }
        },
        [panelOpen, windowHeight, controlsRef],
    );

    return [controlsRef, height, {onResize: handleResize}];
};

const Controls = ({panelOpen}) => {
    const [controlsRef, height, events] = useHeight(panelOpen);

    return (
        <Portal container="map-wrapper">
            <div className="controls" ref={controlsRef}>
                <EventListener target={window} {...events} />
                <ToggleDrawButton />
                <ExportButton />
                <OpacitySlider height={height} />
                <SettingsButton />
            </div>
        </Portal>
    );
};

export default Controls;
